import { FILTRAR_SELECAO_EMPRESA } from '../types';


export default function filtrarSelecaoEmpresa(empresas, texto) {
  return {
    type: FILTRAR_SELECAO_EMPRESA,
    payload: { empresas, texto }
  };
}
